import { render, staticRenderFns } from "./BomTreeModal.vue?vue&type=template&id=38544e17&scoped=true&"
import script from "./BomTreeModal.vue?vue&type=script&lang=js&"
export * from "./BomTreeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38544e17",
  null
  
)

export default component.exports